/* NET CASH FLOW -- the ONE owner of the formula (W-003, 2026-09-24).
 *
 * net cash flow[m] = CFS total_oper[m] + total_invest[m], rounded to the cent.
 * SIGNED: positive = cash generated, negative = cash consumed. Financing (fundraises and the
 * money-market sweep transfer, both in total_fin) is excluded; sweep INTEREST is included,
 * because it reaches operating cash through net income.
 *
 * It was spelled three times, character-equivalent (ScenariosPage's scenario and base arms,
 * and KPIDashboardPage). The operator-facing name was "Net Burn", which read a positive
 * figure -- cash GENERATED -- as money burned. The number was never wrong; the name was.
 * The sign is deliberately NOT flipped: findBreakeven and computeRunway read it as signed.
 */
const r2 = n => Math.round(n * 100) / 100;

export function netCashFlow(cfs, m) {
  const oper = (cfs && cfs.total_oper && cfs.total_oper[m]) || 0;
  const invest = (cfs && cfs.total_invest && cfs.total_invest[m]) || 0;
  return r2(oper + invest);
}
